import { initializeApp } from 'firebase/app';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDGRGEvN2AbQkOoMJTCgUZr1-S2H1OZkkg",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "therapeu-time.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "therapeu-time",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "therapeu-time.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "602962278551",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:602962278551:web:9428097291f3b3f655d1d2",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-JQX03NWZDD"
};

// VAPID key for FCM (from Firebase Console -> Project Settings -> Cloud Messaging)
export const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY || "BAVsM274lYEiNkNk5KCaD_zD5iAJOsX3sejwq0ig4OzxfyUH4DviUi89uJkguA7J_tb8Ge9LcknNQyGK9AtGxwc";

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export default firebaseApp;

